import React from "react";
import { withStyles, createStyles, Theme } from "@material-ui/core/styles";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  Button
} from "@material-ui/core";
import {
  FavoriteBorder as FavoriteBorderIcon,
  Favorite as FavoriteIcon,
  Star as StarIcon,
  StarBorder as StarBorderIcon,
  MoreHoriz
} from "@material-ui/icons";
import { Rating } from "@material-ui/lab";
import ReviewsController, { Props } from "./ReviewsController";
import { userIcon } from "./assets";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

const styles = (theme: Theme) =>
  createStyles({
    pageWrapper: {
      minHeight: "100vh",
      backgroundColor: "#f5f7fb",
      padding: "40px 20px",
      display: "flex",
      justifyContent: "center",
    },

    container: {
      width: "100%",
      maxWidth: 900,
      backgroundColor: "#ffffff",
      borderRadius: 12,
      boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
      overflow: "hidden",
    },

    header: {
      padding: theme.spacing(2, 3),
      borderBottom: `1px solid ${theme.palette.divider}`,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },

    headerLeft: {
      display: "flex",
      alignItems: "center",
      gap: 16,
    },

    backButton: {
      textTransform: "none",
      fontWeight: 600,
    },

    reviewList: {
      padding: "10px 0",
    },

    reviewCard: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      boxShadow: "none",
    },

    reviewContent: {
      padding: "20px 24px !important",
    },

    userInfo: {
      marginLeft: 14,
      flex: 1,
    },

    userName: {
      fontSize: 15,
      fontWeight: 600,
      color: "rgb(72 115 165)",
      marginRight:"10px"
    },

    reviewText: {
      marginTop: 8,
      fontSize: 14,
      color: "#444",
      lineHeight: "20px",
    },

    rating: {
      "& .MuiRating-icon": {
        color: "#FFC107",
        fontSize: 18,
      },
    },

    likeButtonCenter: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },

    likeCount: {
      fontSize: 12,
      color: "rgb(72 115 165)",
      marginTop: 4,
    },
  });

class ReviewsBUser extends ReviewsController {
  constructor(props: Props) {
    super(props);
  }

  formatTimeAgo(dateString: string) {
    const date = new Date(dateString);
    const now = new Date();
    const diff = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (diff < 60) return "Just now";
    if (diff < 3600) return `${Math.floor(diff / 60)}m`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
    if (diff < 2592000) return `${Math.floor(diff / 86400)}d`;
    if (diff < 31536000) return `${Math.floor(diff / 2592000)}mo`;
    return `${Math.floor(diff / 31536000)}y`;
  }

  render() {
    const { classes, navigation } = this.props;
    const { reviewDataShow, sortAnchorEl, sortBy } = this.state;

      return (
          <Box className={classes.pageWrapper}>
              <Box className={classes.container}>

                  {/* HEADER */}
                  <Box className={classes.header}>
                      <Box className={classes.headerLeft}>
                          <IconButton onClick={() => navigation.goBack()}>
                              <ArrowBackIcon />
                          </IconButton>

                          <Typography variant="h6" style={{ fontWeight: 600 }}>
                              {reviewDataShow?.length || 0} Reviews
                          </Typography>
                      </Box>

                      <Button
                          onClick={this.handleMenuOpen}
                          startIcon={<MoreHoriz />}
                      >
                          {/* Sort */}
                      </Button>

                      <Menu
                          anchorEl={sortAnchorEl}
                          open={Boolean(sortAnchorEl)}
                          onClose={() => this.handleMenuClose()}
                      >
                          <MenuItem
                              selected={sortBy === "newest"}
                              onClick={() => this.handleMenuClose("newest")}
                          >
                              Newest First
                          </MenuItem>
                          <MenuItem
                              selected={sortBy === "highest"}
                              onClick={() => this.handleMenuClose("highest")}
                          >
                              Highest Rated
                          </MenuItem>
                      </Menu>
                  </Box>

                  {/* REVIEW LIST */}
            <Box className={classes.reviewList}>
              {Array.isArray(this.state.reviewDataShow) &&
                this.state.reviewDataShow.map((review: any) => {
                  console.log("review123", review);

                  return (
                    <Card key={review.id} className={classes.reviewCard}>
                      <CardContent className={classes.reviewContent}>
                        <Box display="flex" justifyContent="space-between">
                          <Box display="flex">
                            <Avatar
                              src={review.userAvatar || undefined}
                              alt={review.userName}
                            >
                              {!review.userAvatar
                                ? review.userName
                                  ? review.userName.charAt(0).toUpperCase()
                                  : <img src={userIcon} alt="user" />
                                : null}
                            </Avatar>

                            <Box className={classes.userInfo}>
                              <Box display="flex" alignItems="center">
                                <Typography className={classes.userName}>
                                  {review.userName}
                                </Typography>

                                <Typography
                                  variant="caption"
                                  color="textSecondary"
                                  style={{ marginRight: "10px" }}
                                >
                                  {this.formatTimeAgo(review.date)}
                                </Typography>

                                <Rating
                                  value={review.rating}
                                  readOnly
                                  precision={0.5}
                                  icon={<StarIcon fontSize="inherit" />}
                                  emptyIcon={<StarBorderIcon fontSize="inherit" />}
                                  size="small"
                                  className={classes.rating}
                                />
                              </Box>

                              <Typography className={classes.reviewText}>
                                {review.comment}
                              </Typography>
                            </Box>
                          </Box>

                          {/* LIKE BUTTON */}
                          <Box className={classes.likeButtonCenter}>
                            <IconButton
                              onClick={() => this.toggleLike(review.id)}
                              disableRipple
                            >
                              {review.isLiked ? (
                                <FavoriteIcon style={{ color: "#FF5252" }} />
                              ) : (
                                <FavoriteBorderIcon />
                              )}
                            </IconButton>

                            <span className={classes.likeCount}>
                              {review?.like_count ?? review?.likes ?? 0}
                            </span>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  );
                })}
            </Box>
              </Box>
          </Box>
      );
  }
}

export default withStyles(styles)(ReviewsBUser);
